import { Md5 } from 'ts-md5'

const alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

export const klStringUtil = {
	/**
	 * 生成随机字符串
	 * */
	nonce(len: number=12): string {
		let result = ''
		const size = alpha.length
		for (let i = 0; i < len; i++) {
			result += alpha[Math.floor(Math.random() * size)]
		}
		return result
	},

	/**
	 * md5 签名
	 * */
	md5(source: string): string {
		return Md5.hashStr(source)
	},

	/**
	 * md5 签名
	 * */
	md5OfObject(source: unknown): string {
		return Md5.hashStr(JSON.stringify(source))
	},


	/**
	 * 解析 int
	 * */
	parseInt(val: any): number {
		if (val === undefined || val === null) return NaN
		if (typeof val === 'number') return val
		return parseInt(`${val}`)
	},

	/**
	 * 解析 Float
	 * */
	parseFloat(val: any): number {
		if (val === undefined || val === null) return NaN
		if (typeof val === 'number') return val
		return parseFloat(`${val}`)
	},

	/**
	 * 解析 Float
	 * */
	parseBool(val: any): boolean | undefined {
		if (val === undefined || val === null) return undefined
		if (typeof val === 'boolean') {
			return val
		}
		if (typeof val === 'string') {
			val = val.trim().toLowerCase()
			if (val === 'true') return true
			if (val === 'false') return false
			val = parseFloat(val)
			if (isNaN(val)) return undefined
		}
		if (typeof val === 'number') {
			return val > 0
		}
		return undefined
	},

	/**
	 * 解析字符串
	 * */
	parseString(val: any): string | undefined {
		if (val === undefined || val === null) return undefined
		if (typeof val === 'string') return val
		return `${val}`
	},
}
